import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../actions/auth";

const Logout = ({ title }) => {
  // set title
  document.title = title;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Define performLogout outside the useEffect and wrap it in useCallback
  const performLogout = React.useCallback(async () => {
    await localStorage.removeItem("token");
    await dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    // Perform logout and redirect
    performLogout().then(() => {
      window.location.href = "/";
    });
  }, [performLogout, navigate]); // Include performLogout in the dependency array

  return (
    <div className="logout-page">
      <h1>Logging out...</h1>
    </div>
  );
};

export default Logout;
